import Joi from 'joi';

export const CreateMagazineArticleSchema = Joi.object({
  title: Joi.string().required().messages({ 'string.empty': 'Required!' }),
  tags: Joi.array().items(Joi.string()).allow(null),
});
